export default __webpack_public_path__ + "static/media/pdf-background.83366acb.jpg";